<template>
  <div class="mobile-fixed-bottom-popup">
    <button
      type="button"
      class="mobile-fixed-bottom-popup__button-cross"
      @click="onClose"
      aria-label="Закрыть окно"
    />
    <slot />
  </div>
</template>

<script>

/**
 * @description Компонент следующего шага инструкции.
 * @type {Vue}
 */
export default {
  name: 'NextStepSettingInstruction',
  methods: {
    /**
     * @description Обработать событие закрытия попапа.
     * @returns {void}
     */
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.mobile-fixed-bottom-popup {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding-block: 15px;
  padding-inline: 22px 40px;
  color: #0489e0;
  background-color: white;
  box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.06);
  z-index: 4;
  &__button-cross {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 17px;
    height: 17px;
    background-image: url("@/assets/img/exit-black.svg");
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}
@media screen and (max-width: 480px) {
  .mobile-fixed-bottom-popup {
    padding: 10px;
    padding-right: 40px;
  }
}
</style>
